import React, { useRef } from "react";
import { bool, func } from "prop-types";
import { Trans, useTranslation } from "@lib/i18n";
import { useDispatch } from "react-redux";

import Typography from "@components/shared/Typography";
import Modal from "@components/shared/Modal";
import { Button } from "@components/shared/Button";

import { setIsCEESubsidySelectedAction } from "@redux/actions/dealActions";
import { ceeSubsidySelectChangeEvent } from "@gtm/events/homepage";
import gtm from "@gtm/core";

const CEESubsidyDetailsModal = ({
  isOpen,
  isCEESubsidySelected,
  onClose,
  closeCeeSubsidyModal,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const modalLastElement = useRef(null);

  const toggleCEESubsidy = newStatus => {
    const ceeSubsidy = newStatus ? "yes" : "no";
    const label = t(`price.ceeSubsidy.modal.button.${ceeSubsidy}`);

    gtm.fire(ceeSubsidySelectChangeEvent({ ceeSubsidy, label }));

    if (newStatus !== isCEESubsidySelected) {
      dispatch(setIsCEESubsidySelectedAction(newStatus));
    }

    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      withCloseIcon
      lastElement={modalLastElement}
      ariaLabel={t("price.ceeSubsidy.modal.heading")}
      onClose={closeCeeSubsidyModal}
    >
      <div className="flex flex-col gap-4 pr-4">
        <Typography className="text-primaryDark text-xl font-semibold uppercase">
          {t("price.ceeSubsidy.modal.heading")}
        </Typography>
        <div className="text-sm">
          <Trans
            i18nKey="price.ceeSubsidy.modal.mainText"
            components={{
              a: (
                <a
                  className="text-primaryOrange underline cursor-pointer"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              b: <b />,
              br: <br />,
            }}
          />
        </div>
        <Typography className="font-semibold text-center text-primaryDark">
          {t("price.ceeSubsidy.modal.promptText")}
        </Typography>
        <div className="flex flex-col flex-wrap justify-center gap-4 pb-2 smallMobile:flex-row">
          <Button variant="secondary" onClick={() => toggleCEESubsidy(false)}>
            {t("price.ceeSubsidy.modal.button.no")}
          </Button>
          <Button
            ref={modalLastElement}
            variant="primary"
            onClick={() => toggleCEESubsidy(true)}
          >
            {t("price.ceeSubsidy.modal.button.yes")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

CEESubsidyDetailsModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  closeCeeSubsidyModal: func.isRequired,
  isCEESubsidySelected: bool,
};

export default CEESubsidyDetailsModal;
